module.exports = __webpack_public_path__ + "static/media/3.ada38aff.png";